<template>
    <div class="lsva-trucks-filter l-inline l-center-v l-gap-2">
        <div>
            <BaseInput
                :value="$route.query.search"
                :debounce="400"
                :placeholder="$t('searchForTrucks')"
                @input="setSearchQuery"
            >
                <template #icon>
                    <SearchIcon width="16" height="16" />
                </template>
            </BaseInput>
        </div>

        <div>
            <BaseMultiselect
                :value="$route.query.status"
                :placeholder="$t('allStatuses')"
                :options="statusOptions"
                :custom-label="
                    option => $t(`shared.lsva.truckStatus.${option}`)
                "
                @input="setSearchStatus"
            />
        </div>

        <div>
            <a
                v-if="$route.query.search || $route.query.status"
                @click="handleFilterClear"
            >
                {{ $t('clearFilter') }}
            </a>
        </div>
    </div>
</template>

<script>
import BaseInput from '../redesigned/BaseInput.vue'
import BaseMultiselect from '../redesigned/BaseMultiselect.vue'
import SearchIcon from '../icons/SearchIcon.vue'

export default {
    name: 'LsvaTrucksFilter',
    components: {
        BaseInput,
        BaseMultiselect,
        SearchIcon,
    },
    data() {
        return {
            statusOptions: [
                'ALL',
                'VEHICLE_OUTSIDE_TOLL_DOMAIN',
                'GNSS_WITH_TRIP',
                'GNSS_WITHOUT_TRIP',
                'WITHOUT_ACCESS',
                'GPS_ISSUE',
            ],
        }
    },
    methods: {
        handleFilterClear() {
            // redirect to the same page with search and status excluded from query
            const newQuery = { ...this.$route.query }
            delete newQuery.search
            delete newQuery.status

            this.$router.push({
                query: newQuery,
            })
        },
        setSearchQuery(value) {
            if (!value) {
                const newQuery = { ...this.$route.query }
                delete newQuery.search
                this.$router.push({
                    query: newQuery,
                })

                return
            }

            this.$router.push({
                query: {
                    ...this.$route.query,
                    search: value,
                },
            })
        },
        setSearchStatus(value) {
            if (value === 'ALL') {
                const newQuery = { ...this.$route.query }
                delete newQuery.status
                this.$router.push({
                    query: newQuery,
                })

                return
            }

            this.$router.push({
                query: {
                    ...this.$route.query,
                    status: value,
                },
            })
        },
    },
}
</script>

<i18n>
{
    "en": {
        "allStatuses": "All Messages",
        "clearFilter": "Clear filter",
        "searchForTrucks": "Search for trucks"
    },
    "de": {
        "allStatuses": "Alle Meldungen",
        "clearFilter": "Filter zurücksetzen",
        "searchForTrucks": "Suche nach Lastwagen"
    },
    "fr": {
        "allStatuses": "Tous les Messages",
        "clearFilter": "Supprimer le filtre",
        "searchForTrucks": "Recherche de camions"
    },
    "it": {
        "allStatuses": "Tutti i Messaggi",
        "clearFilter": "Annullare il filtro",
        "searchForTrucks": "Ricerca di camion"
    }
}
</i18n>

<style lang="scss" scoped>
a {
    font-size: 13px;
    color: #000;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        text-decoration: none;
    }
}
</style>
